import React from "react"
import { graphql } from "gatsby"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import ContentContainer from "../components/contentContainer"
import FluidContainer from "../components/fluidContainer"
import { Header1 } from "../components/headings"
import ReactMarkdown from "react-markdown"
import SEO from "../components/seo"
import beltHat from "../images/belt-and-hat.png"

const InfoContainer = styled.div`
  background-color: #eaecec;
  padding: 2rem;
  font-family: roboto;
  font-size: 16px;
  font-weight: 300;
  color: black;
`

const BeltHat = styled.img`
  display: block;
  width: 100%;
  max-width: 640px;
  height: auto;
  margin: 1.5rem auto 2.5rem;
  filter: drop-shadow(0 8px 14px rgba(0, 0, 0, 0.35));
`
const About = ({ data }) => (
  <Layout>
    <SEO title="About us" keywords={[`eating`, `contests`, `official`]} />
    <FluidContainer>
      <ContentContainer>
        <InfoContainer>
          <Header1>{data.strapiPages.title}</Header1>
          <BeltHat
            src={beltHat}
            alt="Nathan's Famous World Champion belt and Major League Eating boater hat"
          />
          <ReactMarkdown
            escapeHtml={false}
            source={data.strapiPages.mainCopy}
          />
        </InfoContainer>
      </ContentContainer>
    </FluidContainer>
  </Layout>
)

export default About

export const pageQuery = graphql`
  query AboutQuery {
    strapiPages(selector: { eq: "about" }) {
      mainCopy
      title
    }
  }
`
